export const apiName: string = 'combustiveis-bens';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-combustiveis/data.service.ts
 **/